var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.availableFlags),function(item,idx){return _c('span',{key:idx,class:_vm.handleClass(item),staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.handleClick(item)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }